// extracted by mini-css-extract-plugin
export var sliderRange = "_qh-2";
export var sliderRoot = "_qh-0";
export var sliderThumb = "_qh-3";
export var sliderTrack = "_qh-1";